(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda appointment status
    module.directive('agendaAppointmentStatus', [
        '$rootScope',         
        '$timeout',
        'AppointmentState', 
        'AppointmentService', 
        'AgendaBroadcast', 
        'WebsocketService',
        'WebsocketRegisterType',
        '$translate',
        function (
            $rootScope,             
            $timeout,
            AppointmentState, 
            AppointmentService, 
            AgendaBroadcast,
            WebsocketService,
            WebsocketRegisterType,
            $translate) {

        var directive = {
            restrict: 'E',
            templateUrl: '/app/agenda/templates/agenda-appointment-status.template.html',
            scope: {
                id: '=',
                state: '=',
                disabled: '='
            },
            link: link
        };
        return directive;

        function link(scope, element) {
            scope.states = [];            
            scope.currentState = AppointmentState['None'];
            scope.blink = false;

            activate();

            function listen() {
                // status changed
                var listener = scope.$on(AgendaBroadcast.StatusUpdated, function (event, appointmentId, state) {
                    if (appointmentId !== scope.id) {
                        return;
                    } //if
                    else {
                       setState(state);               
                    }
                });

                var wsAppointmentStateUpdated = WebsocketService.register(WebsocketRegisterType.AgendaStateUpdate, function (obj) {

                    if (obj.data.appointmentId === scope.id) {
                        
                        var newState = obj.data.state;

                        if (scope.currentState &&
                            scope.currentState.value === newState) { 
                                return; 
                        }
                                                
                        $timeout(function() {
                            setState(newState);
                            scope.blink = true;
                        });

                        let appointmentDate = moment(obj.data.date);
                        let message = $translate.instant('patient_arrived', {datetime: appointmentDate.format('dddd DD MMMM YYYY H:mm')});
                        Alert.success(message);
                    }
                });


                // on destroy
                scope.$on("$destroy", function () {
                    listener();
                    listener = null;

                    if (wsAppointmentStateUpdated) {
                        WebsocketService.unregister(wsAppointmentStateUpdated.id);
                    }
                });

            }

            function setState(stateValue) {
                scope.currentState = scope.states.filter(function(s) {
                    return s.value === stateValue;
                })[0];
            }

            // change state of appointment
            scope.change = function (newState) {
                // is same state ?
                if (scope.currentState &&
                    scope.currentState.value === newState.value) { 
                        return; 
                }

                setState(newState.value);

                // update
                AppointmentService.state(scope.id, newState.value).then(function (response) {                    
                    // inform that status changed -> current item is listening and maybe items in modal windows...
                    $rootScope.$broadcast(AgendaBroadcast.StatusUpdated, scope.id, newState.value);
                });
            };


            // activation work
            function activate() {

                angular.forEach(AppointmentState, function (state) {
                    scope.states.push(state);
                });
                setState(scope.state);      // set initial state to the state passed to this directive (=number)
                           
                listen();               
            }
        }
}]);
})();